import { Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { Store } from 'antd/lib/form/interface';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';
import React from 'react';

interface IFormWrapper {
    layoutPosition?: 'vertical' | 'horizontal' | 'inline';
    onFinish: (values: Store) => void;
    onFinishFailed?: (errorInfo: ValidateErrorEntity) => void;
    outForm?: FormInstance;
    name?: string;
    preserve?: boolean;
    requiredMark?: boolean;
    hideLabel?: boolean;
    labelAlign?: 'left' | 'right';
    colon?: boolean;
    size?: 'small' | 'middle' | 'large';
    modalForm?: boolean;
}

/* Obal pro formuláře */
const FormWrapper: React.FC<IFormWrapper> = props => {
    const [form] = Form.useForm();
    const {
        onFinish,
        children,
        layoutPosition = 'vertical',
        labelAlign = 'right',
        onFinishFailed,
        outForm,
        name = 'login',
        preserve,
        requiredMark,
        hideLabel,
        colon,
        size,
        modalForm
    } = props;
    const layout = hideLabel
        ? {
              wrapperCol: {
                  span: 24
              },
              labelCol: {
                  span: 0
              }
          }
        : layoutPosition === 'horizontal'
        ? {
              wrapperCol: {
                  span: modalForm ? 14 : 9
              },
              labelCol: {
                  span: modalForm ? 10 : 5
              }
          }
        : {
              labelCol: {
                  span: 24
              }
          };
    return (
        <Row justify="start">
            <Form
                {...layout}
                labelAlign={labelAlign}
                layout={layoutPosition}
                form={outForm ? outForm : form}
                name={name}
                preserve={preserve}
                size={size}
                initialValues={{
                    remember: true
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                style={{
                    width: '100%'
                }}
                requiredMark={requiredMark}
                colon={colon}
            >
                {children}
            </Form>
        </Row>
    );
};

export default FormWrapper;
